import { render, staticRenderFns } from "./recycleBinForAdmin.vue?vue&type=template&id=b5a5a82a&scoped=true&"
import script from "./recycleBinForAdmin.vue?vue&type=script&lang=js&"
export * from "./recycleBinForAdmin.vue?vue&type=script&lang=js&"
import style0 from "./recycleBinForAdmin.vue?vue&type=style&index=0&id=b5a5a82a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a5a82a",
  null
  
)

export default component.exports